/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {LookupCustomerRequest} from '@cash-web/protos/squareup/franklin/app/customer.pb'
import {LookupCustomerResponse} from '@cash-web/protos/squareup/franklin/app/customer.pb'


export const lookupCustomer = (request: LookupCustomerRequest, options?: CashRequestOptions) => post<LookupCustomerRequest, LookupCustomerResponse>("/2.0/cash/lookup-customer", request, {...options, rejectOnError: true })